import React from 'react';

const LoopScaleMarking = React.memo(({ loopData, getMarkingPosition, scaleY }) => {
  const x = getMarkingPosition(loopData.position, false);

  return (
    <g className="loop-scale-marking">
      {/* Cerchietto SOPRA la linea per essere visibile */}
      <circle
        cx={x} cy={scaleY}
        r={3}
        fill="#F59E0B"
        stroke="#D97706"
        strokeWidth={1}
        style={{ zIndex: 10 }} // Assicura che sia sopra la linea
      />

      {/* Testo alla stessa altezza di HEAD/TAIL */}
      <text
        x={x} y={scaleY + 15}
        className="text-xs fill-amber-600 font-medium"
        textAnchor="middle"
        fontSize="10"
      >
        LOOP{loopData.index}
      </text>
      <text
        x={x} y={scaleY + 25}
        className="text-xs fill-amber-600"
        textAnchor="middle"
        fontSize="9"
      >
        {Math.round(loopData.position)}mm
      </text>
    </g>
  );
});

export default LoopScaleMarking;
